//@ts-ignore
//@ts-nocheck
import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useForm, FormContext } from "react-hook-form";

import {
  addAnswers,
  addSupport,
  alert,
  modalSteps,
  stateAlert,
  stepPosition,
} from "../../Store/simulate/actions";
import useBeforeFirstRender from "../../customHook/useBeforFirstRender";

import BreadCrumbs from "../BreadCrumbs";
import Quiz from "./FormElements/quiz";
import ModalSteps from "./FormElements/ModalSteps";
import Button from "../../Components/FormElements/Button";
import FormTitle from "../../Components/FormElements/FormTitle";
import NavCase from "../../Components/FormElements/NavCase";
import NavResponsive from "../../Components/FormElements/NavResponsive";
import Footer from "../../Components/Footer";

import { Answers, RootState } from "../../interfaces/additionalInfo";
import { RootQuiz } from "../../interfaces/quiz";

import IconBack from "../../Resources/svg/Icons/IconBack";
import IconDownload from "../../Resources/svg/Icons/IconDownload";
import ModalCapitalSimulation from "../../Components/modalCapitalSimulation";
import AlertNotifications from "../../Components/FormElements/AlertNotifications";
import { API } from "aws-amplify";
import { currency } from "../../Utils/utils";
import IconDelete from "../../Resources/svg/Icons/IconDelete";

// heredado

// 
export const AdditionalInfoPart1 = () => {
  const [loadingClick, setLoadingClick] = useState(false);
  const client = useSelector((state: RootState) => state.simulate.policy.client);
  const data = useSelector((state: RootQuiz) => state.quiz.additionalInfo1);
  const [enableButton, setEnableButton] = useState(true);
  const contractorData = client.contratante;
  const dataClient = client.datosCliente;
  const datosSimulacion = client.datosSimulacion;
  const {isAbove10k, isAbove50k, usdToPenRate, totalPremiumInUSD} = client.acumuladoOrigenesFondo;
  const history = useHistory();
  const dispatch = useDispatch();

  const codProd = client.producto.codigo;
  
  let dataRedux;

    const inputFileRef = useRef(null);
    
    const methods = useForm({
      mode: "onChange",
      defaultValues: {},
  });
  const {
    handleSubmit,
    errors,
    watch,
    formState: { isValid },
  } = methods;
  const [orders, setOrders] = useState([]);
  const [dataQuiz, setDataQuiz] = useState([]);
  const [showSupport, setShowSupport] = useState<boolean>(false);
  const [capitalSimulationActive, setCapitalSimulationActive] = useState(false);
  const [resultedAmount, setResultedAmount] = useState();
  const [calculatedAmount, setCalculatedAmount] = useState();
  const [supportFile, setSupportFile] = useState();

  const [loadingSupport, setLoadingSupport] = useState(false);
  const suppRef = useRef(null);

  const onSubmit = (values: any) => {
    setLoadingClick(true);
    for (let [key, value] of Object.entries(values)) {
      if (Array.isArray(value)) {
        values[key] = value.join(",");
      }
    }

    if(Object.keys(client.acumuladoOrigenesFondo).length > 0) {
      if(isAbove10k && !validateAmounts(values)) {
        setCapitalSimulationActive(true);
        setLoadingClick(false);
        return;
      }
    };

    dispatch(addAnswers(values));
    setTimeout(() => {
      setLoadingClick(false);
      history.push("/cotizaciones/info-complementaria-2");
    }, 500);

    dispatch(stepPosition(6));
  };

  const amountValuesData = (valuesQuiz: any) => {
    const parents = dataQuiz
        .filter(item => item.questionType === "formGroup" && item.active);

    const result = parents.flatMap(parent => {
        const inputGroup = parent.childControls.find(child => child.questionType === "inputGroup");
        if (!inputGroup || !inputGroup.childControls) return [];

        const selectItem = inputGroup.childControls.find(child => child.questionType === "select");
        const inputItem = inputGroup.childControls.find(child => child.questionType === "input");

        if (!selectItem || !inputItem) return [];

        const getValue = (key: string) => valuesQuiz[key] || null;

        const parentData = {
            selectValue: getValue(selectItem.sk),
            inputValue: parseNumberString(getValue(inputItem.sk)),
        };
        const childrenData = Object.keys(valuesQuiz)
            .filter(key => key.startsWith(selectItem.sk + "/") || key.startsWith(inputItem.sk + "/"))
            .reduce((acc, key) => {
                const [, index] = key.split("/");
                if (!index) return acc;

                const existingChild = acc[index] || { selectValue: null, inputValue: null };
                if (key.startsWith(selectItem.sk)) existingChild.selectValue = valuesQuiz[key];
                if (key.startsWith(inputItem.sk)) existingChild.inputValue = parseNumberString(valuesQuiz[key]);

                acc[index] = existingChild;
                return acc;
            }, {});

        return [parentData, ...Object.values(childrenData)];
    });

    return result;
};


const validateAmounts = (valuesQuiz: any) => {
  const capitalSimulation = resultedAmount.amount;
  const currencySimulation = resultedAmount.currency;
  const exchangeRate = usdToPenRate;

  const tolerance = 1.00;
  const amounts = amountValuesData(valuesQuiz);
  let totalSum = 0;

  amounts.forEach(({ selectValue, inputValue }) => {
      if (!inputValue) return;

      if (selectValue === "Soles") {
          totalSum += currencySimulation === "PEN" ? inputValue : inputValue / exchangeRate;
      } else if (selectValue === "Dólares") {
          totalSum += currencySimulation === "USD" ? inputValue : inputValue * exchangeRate;
      }
  });


  totalSum = parseFloat(totalSum.toFixed(2));
  setCalculatedAmount({ currency: currencySimulation, amount: totalSum });

  return Math.abs(totalSum - capitalSimulation) <= tolerance;
};


  const handleSupportFile = (files) => {
    let fileName = "Seleccione un archivo";
    let fileValue;
    if (files.length !== 0) {
      fileName = files[0].name;
      fileValue = files[0];

      validateFile(fileName, fileValue);
    }
    inputFileRef.current.value = null;
  };

  const validateFile = (fileName, fileValue) => {
    const allowedExtensions = [".jpg", ".png", ".pdf", ".jpeg"];
    const includesValidExtension = allowedExtensions.some(ext => fileName.toLowerCase().endsWith(ext));
    const fileSizeInMB = fileValue.size / 1024 / 1024;
    const maxSize = 15;
  
    if (!includesValidExtension) {
      setAlert(
        "error",
        "Archivo inválido",
        "El tipo de archivo seleccionado no es válido."
      );
      return;
    }
  
    if (fileSizeInMB > maxSize) {
      setAlert(
        "error",
        "Archivo demasiado grande",
        `El archivo no debe superar los ${maxSize} MB.`
      );
      return;
    }
  
    getSupport(fileName, fileValue);
  };
  

  const getSupport = async(fileName, fileValue) => {
    setLoadingSupport(true);
    setLoadingClick(true);
    toBase64(fileValue).then(async (base64File) => {
      const request = {
        body: {
          simulacionId: client.idSimulacion,
          documentoContratante: contractorData.nroDoc,
          documentName: fileName,
          documentBase64: extractBase64(base64File),
        }
      };
      try {
        const response = await API.post("api-rentas", "/save-support-file", request);
        const { documentId, url } = response;
        dispatch(addSupport({ documentId, url }));
        setAlert(
          "success",
          "¡Sustento procesado!",
          "El sustento ha sido cargado correctamente."
        );
        setSupportFile({nameSupport: fileName, urlSupport: url});
        setLoadingSupport(false);
        setLoadingClick(false);
      } catch (error) {
        console.error(error);
        setAlert(
          "error",
          "Error",
          "El sustento no ha podido ser procesado."
        );
        setLoadingSupport(false);
        setLoadingClick(false);
      }
    })
  }

  const extractBase64 = (str) => str.split(",")[1];

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
  });

  const setAlert = (type, title, message) => {
    dispatch(stateAlert(true));
    dispatch(
      alert({
        type,
        title,
        message,
      })
    );

    setTimeout(() => {
      dispatch(stateAlert(false));
    }, 2500);
  };

  useBeforeFirstRender(dataClient);

  useEffect(() => {
    dispatch(addSupport({}));
    dispatch(stepPosition(5));

    window.digitalData.push({
      virtual: {
        name: "aiv:inversion-global:cotizar:datos-origen",
      },
      event: "trackVirtual",
    });
  }, []);

  const handleOpenModal = () => {
    dispatch(modalSteps(true));
  };

  const parseNumberString = (numStr: string) => {
    if (!numStr) return null;
    return Number(numStr.replace(/,/g, ''));
  }

  const hideQuizSections = (array) => {
    return array.map(item => 
      item.questionType === "formGroup" 
        ? { ...item, active: false } 
        : item
    );
  }

  const handleDeleteSupport = () => {
    setSupportFile(null);
    dispatch(addSupport({}));
  };

  useEffect(() => {
    const isPEN = datosSimulacion.moneda.iso === "PEN";
    const finalAmount = isAbove50k 
      ? (isPEN ? totalPremiumInUSD * usdToPenRate : totalPremiumInUSD) 
      : datosSimulacion.prima;
  
    setResultedAmount({ currency: datosSimulacion.moneda.iso, amount: finalAmount });
  }, [client]);

  const validateSupportFile = () => supportFile && Object.keys(supportFile).length > 0 && !Object.keys(errors).length > 0 ? true : false;

  useEffect(() => {
    if (Object.keys(data).length > 0) {
      setDataQuiz(hideQuizSections(data));
    }
  }, [data]);

  return (
    <>
      <a
        style={{ display: "none" }}
        target="_blank"
        rel="noopener noreferrer"
        href={supportFile ? supportFile.urlSupport : null}
        ref={suppRef}
      />
      <div className="wrap">
        <NavResponsive position={5} title="Datos sobre origen de fondo"/>
        <div className="content-box d-flex">
          <div className="nav-case">
            <BreadCrumbs
              rutas={[{ link: "Simulaciones" }, { link: "Cotización" }]}
            />
            <div className="nav-case__routing">
              <IconBack className="nav-case__back" onClick={handleOpenModal} />
              <div className="nav-case__title">Datos sobre origen de fondo</div>
              <NavCase />
            </div>
          </div>
          <div className="form-register">
            <FormTitle
              title="Ingresa los datos del contratante sobre prevención de lavado de activos y del financiamiento"
              parrafo="El contratante es la persona que es titular de la póliza y asegurado a la vez."
            />
            <FormContext {...methods}>
              <form onSubmit={handleSubmit(onSubmit)}>
                {dataQuiz.length > 0 && (
                  <Quiz
                    data={dataQuiz}
                    setData={setDataQuiz}
                    orders={orders}
                    setOrders={setOrders}
                    setShowSupport={setShowSupport}
                    codProduct={codProd}
                    acumuladoOrigenesFondo={client.acumuladoOrigenesFondo}
                    resultedAmount={isAbove10k && resultedAmount}
                    variant={1}
                  />
                )}
                {showSupport && (
                  <div
                  className="clientForm__add-support"
                  >
                    {supportFile ? (
                      <>
                        <div className="clientForm__add">
                          <p className="clientForm__add-text" onClick={() => suppRef.current.click()}>
                            {supportFile.nameSupport}
                          </p>
                        </div>
                        <div onClick={() => handleDeleteSupport()}>
                          <div className="clientForm__add">
                            <IconDelete />
                            <p className="clientForm__add-text">
                              Eliminar
                            </p>
                          </div>
                        </div>
                      </>
                    ) : (
                      <div className={`clientForm__add ${loadingSupport ? "disabled-action" : ""}`} onClick={() => !loadingSupport ? inputFileRef.current.click() : false}>
                        <IconDownload />
                        <p className="clientForm__add-text">
                          { ['RG'].includes(codProd) ? 'Subir Sustento (obligatorio)' : 'Subir Sustento (opcional)' }
                        </p>
                      </div>
                    )}
                  </div>
                )}
                <div className="form-register__border"></div>
                <div className="form-register__buttom form-step">
                  { ['RG'].includes(codProd) ? <Button
                    type="submit"
                    className={loadingClick ? "is-loading" : ""}
                    disabled={
                      validateSupportFile() && isValid ? false : true
                    }
                  >
                    Continuar
                  </Button> : (
                    <>
                        <Button
                    type="submit"
                    className={loadingClick ? "is-loading" : ""}
                    disabled={
                      (Object.keys(errors).length || enableButton) && !isValid
                        ? true
                        : false
                    }
                  >
                    Continuar
                  </Button>
                    </>
                  )}
                </div>
              </form>
            </FormContext>
          </div>
        </div>
      </div>
      <input
        type="file"
        ref={inputFileRef}
        accept=".pdf"
        className="hide-input"
        onChange={(e) => handleSupportFile(e.target.files)}
      />
      <ModalCapitalSimulation 
        openModal={capitalSimulationActive} 
        setOpenModal={setCapitalSimulationActive}
        resultedAmount={resultedAmount}
        calculated={calculatedAmount}
        typeAmount={isAbove50k ? "acumulado" : "prima"}
      />
      <ModalSteps />
      <AlertNotifications />
      <Footer />
    </>
  );
};
